<template>
  <div
    :class="{ 'scrollable-container' : isMobile }"
    class="page-selfie-face"
  >
    <loading-preparation
      v-if="isPreparingEnvironment"
      :title="messages.loadingEnvironment"
    />
    <loading-preparation
      v-else-if="isInitializingCapture"
      :title="messages.loadingCamera"
    />
    <!-- Enquanto o SDK da FaceTec é dono da tela, a view renderiza um estado
         neutro. Sem isto o ramo v-else abaixo fica montado por trás do overlay
         do SDK e é exposto no instante em que ele desmonta, piscando a tela
         "Vamos validar sua selfie" antes do resultado chegar. -->
    <loading-preparation
      v-else-if="isSdkSessionActive"
      :show-spinner="true"
      :title="messages.processing"
    />
    <section
      v-else-if="!startCapture && !alert.show"
      class="section-centered section-sm"
    >
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="text-center">
            <div>
              <img
                class="selfie-ilustration"
                src="img/icons/selfie/SelfieBiometricsIllustration.png"
                alt="selfieIlustration"
              >
            </div>
            <div>
              <h2 class="display-3">Vamos validar sua selfie</h2>
              <p class="heading-subtitle">Dicas para tirar uma boa imagem</p>
            </div>
            <div class="instructions">
              <div class="content-instruction">
                <img
                  src="img/icons/common/LightIcon.png"
                  alt="IconLight"
                >
                <p>Escolha um local iluminado</p>
              </div>
              <div class="content-instruction">
                <img
                  src="img/icons/common/NoGlasses.png"
                  alt="IconGlasses"
                >
                <p>Não use óculos, chapéu nem boné</p>
              </div>
              <div class="content-instruction">
                <img
                  src="img/icons/common/EmotionSatisfied.png"
                  alt="IconHair"
                >
                <p>Evite deixar o cabelo no rosto</p>
              </div>
              <div class="content-instruction">
                <img
                  src="img/icons/common/FocusFace.png"
                  alt="IconFace"
                >
                <p>Enquadre o seu rosto</p>
              </div>
              <div class="content-instruction">
                <img
                  src="img/icons/common/ClearBackground.png"
                  alt="IconBackground"
                >
                <p>Use um fundo claro e sem estampas</p>
              </div>

            </div>
            <button
              @click="capture()"
              type="submit"
              class="btn btn-primary mb-3 mb-sm-0"
            >Estou pronto</button>
          </div>
        </div>
      </div>
    </section>
    <div
      v-else
      class="position-relative"
    >
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div
            v-if="!selfieActive && !alert.show"
            class="col-lg-12 text-center"
          >
            <div class="d-flex flex-column justify-space-between align-center">
              <div class="flex-item item flex-image">
                <img
                  v-lazy="'img/icons/selfie/selfie_icon.png'"
                  class="card-img"
                >
              </div>
            </div>
            <div>
              <h1 class="display-3 ">Vamos validar<br>sua selfie</h1>
              <p class="lead">
                Hora de tirar sua foto de identificação.
              </p>
              <div class="btn-wrapper">
                <!-- <base-button
                  v-if="!hasError"
                  class="btn btn-primary mb-3 mb-sm-0"
                  icon="fa fa-camera"
                  @click="capture()"
                >
                  Validar selfie
                </base-button> -->
                <base-button
                  v-if="hasError || canRetry"
                  @click="retryProcess"
                  class="btn btn-primary mb-3 mb-sm-0"
                  icon="fa fa-repeat"
                >
                  Tentar novamente
                </base-button>
              </div>
              <b-message
                v-if="hasError"
                type="is-danger"
              >
                <span v-html="$t(`errors.${errorMsg}`)" />
              </b-message>
            </div>
          </div>
          <slide-y-up-transition v-if="alert.show">
            <div class="col-lg-12 text-center alert-message">
              <div class="d-flex flex-column justify-space-between align-center">
                <div class="flex-item item flex-image">
                  <img
                    v-lazy="'img/icons/common/fail.png'"
                    class="card-img"
                  >
                </div>
              </div>
              <h1 class="display-3 ">
                {{ alert.title }}
              </h1>
              <p>{{ alert.message }}</p>
              <base-button
                @click="alert.action()"
                class="btn btn-primary mb-3 mb-sm-0"
              >
                {{ alert.textButton }}
              </base-button>
            </div>
          </slide-y-up-transition>
          <!-- selfie container -->
          <slide-y-up-transition v-if="selfieActive">
            <div
              id="selfieContainer"
              class="selfieContainer"
            >
              <div
                id="selfieWebcamParent"
                class="selfieWebcamParent"
              >
                <div class="selfieWebcam">
                  <div
                    id="selfieContainerParent"
                    class="selfieContainerParent"
                  >
                    <video
                      class="posicaoAbsolute"
                      playsinline
                      autoplay
                      muted
                    />
                    <canvas
                      id="selfieCanvas"
                      class="selfieCanvas"
                    />
                  </div>
                  <div class="selfieMaskCanvas semOverflow centralizado">
                    <img
                      id="selfieMaskId"
                      class="selfieMaskCanvas centralizado"
                      src="img/icons/selfie/SelfieFrameMask.png"
                    >
                    <img
                      id="selfieMaskIdDetails"
                      class="selfieMaskCanvas centralizado"
                      src="img/icons/selfie/SelfieFrameMaskDetails.png"
                    >
                    <img
                      id="selfieMaskIdOval"
                      class="selfieMaskCanvas centralizado"
                      src="img/icons/selfie/SelfieFrameMaskOval.png"
                    >
                  </div>
                </div>
                <div
                  id="selfieAvisoContainer"
                  class="webcamAviso"
                ><p
                  id="selfieTextoAviso"
                  class="selfieTextoAviso"
                >Aguarde ...</p></div>
                <div
                  id="selfieBotaoAcaoCancelar"
                  class="selfieBotaoAcaoCancelar"
                ><img
                  id="botaoAcaoCancelarImagem"
                  src="img/icons/selfie/IconFechar.png"
                ></div>
                <div
                  id="selfieAlertaErro"
                  class="selfieAlertaErro"
                  style="display: block;"
                ><div class="centralizado alignCenter card-img"><img
                  id="selfieAlertaErroImagem"
                  v-lazy="'img/icons/selfie/IconFalha.png'"
                ><p><b>Atenção</b></p><p id="selfieAlertaErroMensagem">Erro ao validar a selfie, tente novamente</p></div><div
                  id="selfieBotaoAcaoTentarNovamente"
                  @click="retryProcess"
                  class="botaoAcao"
                ><p class="selfieTextoBotaoAcao">Tentar novamente</p></div></div>
              </div>
            </div>
          </slide-y-up-transition>
          <!-- ./selfie container -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { SlideYUpTransition } from 'vue2-transitions'
import { EnrollmentProcessor } from '@/processors/EnrollmentProcessor'
import { ensureFaceTecSdkLoaded, FaceTecCdnPaths } from '@/services/facetec-sdk-loader'
import IncogniaWebSdk from '@incognia/web-sdk'
import * as Sentry from '@sentry/vue'
import LoadingPreparation from '@/components/LoadingPreparation.vue'
import { SELFIE_MESSAGES } from '@/config/selfieMessages'
import { TRANSLATE_SELFIE_FACE } from '@/config/translateSelfieFace'
import { cameraPermissionMixin } from '@/mixins/camera-permission-mixin'
import { getAccessData } from '../auth'

export default {
  name: 'SelfieFaceView',
  components: {
    SlideYUpTransition,
    LoadingPreparation
  },
  mixins: [cameraPermissionMixin],
  data() {
    return {
      dataAccess: null,
      sessionToken: null,
      latestSessionResult: null,
      latestIDScanResult: null,
      selfieActive: false,
      active: false,
      errorMsg: '',
      hasError: false,
      licenceKey: null,
      keyEncrypt: null,
      textKey: null,
      selfieProcess: null,
      startCapture: false,
      isSdkSessionActive: false,
      canRetry: false,
      deviceToken: '',
      isPreparingEnvironment: true,
      isInitializingCapture: false,
      initializationStatus: false,
      validInit: false,
      alert: {
        show: false,
        type: '',
        title: '',
        message: '',
        action: false,
        textButton: ''
      },
      message: {
        show: false,
        text: 'Tempo expirado',
        description: 'Ops, seu tempo de sessão expirou. Por favor, reinicie o processo para podermos valiar'
      }
    }
  },
  computed: {
    ...mapGetters({
      client: 'client',
      device: 'device',
      riskDevice: 'riskDevice',
      riskDeviceId: 'riskDeviceId',
      retryFaceCapture: 'retryFaceCapture'
    }),
    isMobile() {
      return this.device === 'mobile'
    },
    messages() {
      return SELFIE_MESSAGES
    }
  },
  created() {
    this.initializePage()
  },
  methods: {
    ...mapActions([
      'validSelfieFaceTransaction',
      'resetProcessUser',
      'getSessionTokenSelfieFace',
      'validStepTransaction',
      'setLoading',
      'setRetryFaceCapture'
    ]),
    async initializePage() {
      this.resetAlert()
      this.isPreparingEnvironment = true

      try {
        const isValidStep = await this.validStep()

        if (!isValidStep) {
          return
        }

        await this.initRiskDevice()
        this.dataAccess = await getAccessData()
        const hasCameraPermission = await this.validateCameraPermission()

        if (!hasCameraPermission) {
          return
        }

        await this.initializeFaceTec()
      } finally {
        this.isPreparingEnvironment = false
      }
    },
    async validStep() {
      const { success, data } = await this.validStepTransaction({ step: 'selfieFace' })

      if (success) {
        const { data: dataValid } = data
        if (dataValid.success) {
          this.licenceKey = dataValid.key
          this.keyEncrypt = atob(dataValid.keyEncryption)
          this.textKey = atob(dataValid.textKey)
          this.validInit = true
          return true
        } else {
          this.alert = {
            show: true,
            type: 'danger',
            title: SELFIE_MESSAGES.terminalTitle,
            message: SELFIE_MESSAGES.invalidStep,
            action: this.restartProcess,
            textButton: SELFIE_MESSAGES.buttonRestart,
            img: 'fail'
          }
          return false
        }
      } else {
        this.alert = {
          show: true,
          type: 'danger',
          title: SELFIE_MESSAGES.terminalTitle,
          message: this.$t('errors.error_default_restart_transaction'),
          action: this.restartProcess,
          textButton: SELFIE_MESSAGES.buttonRestart,
          img: 'fail'
        }
        return false
      }
    },
    async initializeFaceTec() {
      try {
        const FaceTecSDK = await ensureFaceTecSdkLoaded()

        if (this.initializationStatus) {
          return true
        }

        // Garanta barra final nos diretórios
        FaceTecSDK.setResourceDirectory(FaceTecCdnPaths.resourcesUrl)
        FaceTecSDK.setImagesDirectory(FaceTecCdnPaths.imagesUrl)

        FaceTecSDK.setFaceTecLoggingMode(FaceTecSDK.FaceTecLoggingMode.LocalhostOnly)
        console.debug('[FaceTec][View] Logging mode set to LocalhostOnly.')

        // Inicializa
        this.initializationStatus = false
        const initializationSuccessful = await new Promise((resolve) => {
          const timeout = setTimeout(() => resolve(false), 15000)

          FaceTecSDK.initializeInProductionMode(
            this.textKey,
            this.licenceKey,
            this.keyEncrypt,
            (initialized) => {
              clearTimeout(timeout)
              resolve(initialized)
            }
          )
        })

        console.log('[FaceTec][Init] initializationSuccessful:', initializationSuccessful)

        if (initializationSuccessful) {
          this.initializationStatus = true
          // Localização própria: não dependemos do FaceTecStrings.pt-br.js do CDN
          FaceTecSDK.configureLocalization(TRANSLATE_SELFIE_FACE)
          console.log('SDK inicializado com sucesso.')
          return true
        }

        this.alert = {
          show: true,
          type: 'danger',
          title: SELFIE_MESSAGES.terminalTitle,
          message: SELFIE_MESSAGES.environmentFailure,
          action: this.retryProcess,
          textButton: SELFIE_MESSAGES.buttonRetry,
          img: 'fail'
        }
        const err = new Error(`Falha na inicialização do FaceTec SDK. Transaction: ${this.dataAccess}.`)
        Sentry.captureException(err)
        console.error('Falha ao inicializar o SDK.')
        return false
      } catch (err) {
        console.error('[FaceTec][Init] Erro ao inicializar:', err)
        this.initializationStatus = false
        this.alert = {
          show: true,
          type: 'danger',
          title: SELFIE_MESSAGES.terminalTitle,
          message: SELFIE_MESSAGES.environmentFailure,
          action: this.retryProcess,
          textButton: SELFIE_MESSAGES.buttonRetry,
          img: 'fail'
        }
        return false
      }
    },
    resetAlert() {
      this.alert = {
        show: false,
        type: '',
        title: '',
        message: '',
        action: null,
        textButton: ''
      }
    },
    await(segundos) {
      return new Promise(resolve => {
        setTimeout(resolve, segundos * 1000)
      })
    },
    initializeResultObjects() {
      this.latestSessionResult = null
      this.latestIDScanResult = null
    },
    resetCaptureState() {
      this.sessionToken = null
      this.isSdkSessionActive = false
      this.selfieActive = false
      this.active = false
      this.errorMsg = ''
      this.hasError = false
      this.startCapture = false
      this.canRetry = false
      this.isInitializingCapture = false
      this.initializeResultObjects()
      this.resetAlert()
    },
    async retryProcess() {
      this.setRetryFaceCapture()
      this.resetCaptureState()
      await this.initializePage()
    },
    async capture() {
      if (this.isPreparingEnvironment || this.isInitializingCapture) {
        return
      }

      this.isInitializingCapture = true
      const hasCameraPermission = await this.validateCameraPermission({ requestIfNeeded: true })

      if (!hasCameraPermission) {
        this.isInitializingCapture = false
        return
      }

      this.resetAlert()
      this.hasError = false
      this.errorMsg = ''
      this.startCapture = true
      console.log('Iniciando captura de face...')
      this.initializeResultObjects()

      try {
        if (!this.initializationStatus) {
          if (!this.validInit) {
            this.openTerminalAlert(SELFIE_MESSAGES.environmentFailure)
            return
          }

          const initialized = await this.initializeFaceTec()
          if (!initialized) {
            return
          }
        }

        const { success, data: dataSessionToken } = await this.getSessionTokenSelfieFace({
          key: this.licenceKey,
          agent: navigator.userAgent
        })

        if (!success || dataSessionToken?.status !== 200 || !dataSessionToken?.data?.sessionToken) {
          this.startCapture = false
          this.openTerminalAlert(SELFIE_MESSAGES.startFailure)
          return
        }

        this.sessionToken = dataSessionToken.data
        this.isSdkSessionActive = true
        new EnrollmentProcessor(this.sessionToken.sessionToken, this.client, this, this.retryFaceCapture, this.deviceToken)
      } catch (error) {
        console.error('Erro ao iniciar captura FaceTec:', error)
        this.startCapture = false
        this.openTerminalAlert(SELFIE_MESSAGES.startFailure)
      } finally {
        this.isInitializingCapture = false
      }
    },
    processSessionResultWhileFaceTecSDKWaits(sessionResult, faceScanResultCallback) {
      // eslint-disable-next-line no-undef
      if (sessionResult.status !== FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
        faceScanResultCallback.cancel()
        return
      }
    },
    onFaceTecSDKCompletelyDone() {
      console.log('Processo do FaceTec SDK concluído.')
    },
    runTransaction(transaction) {
      console.log('transaction: ', transaction)
    },
    openTerminalAlert(message, action = this.retryProcess, textButton = SELFIE_MESSAGES.buttonRetry) {
      this.isSdkSessionActive = false
      this.selfieActive = false
      this.startCapture = false
      this.canRetry = false
      this.isInitializingCapture = false
      this.alert = {
        show: true,
        type: 'danger',
        title: SELFIE_MESSAGES.terminalTitle,
        message,
        action,
        textButton
      }
    },
    // Volta para a tela de preparação com a ação "Estou pronto" disponível.
    // Usado quando o usuário fecha a captura do SDK.
    resetToPreparation() {
      this.resetCaptureState()
    },
    openRetryAlert() {
      this.isSdkSessionActive = false
      this.selfieActive = false
      this.startCapture = false
      this.canRetry = true
      this.isInitializingCapture = false
      this.alert = {
        show: true,
        type: 'danger',
        title: SELFIE_MESSAGES.retryTitle,
        message: SELFIE_MESSAGES.retry,
        action: this.capture,
        textButton: SELFIE_MESSAGES.buttonRetry
      }
    },
    // openCameraBlockedAlert, validateCameraPermission e openCameraSettings
    // são fornecidos pelo cameraPermissionMixin
    async sendValidationSelfie(capresult) {
      try {
        const { success, data, error } = await this.validSelfieFaceTransaction({ capture: capresult, deviceToken: this.deviceToken })
        if (success) {
          const { data: dataAnalisys } = data

          if (dataAnalisys.success && !dataAnalisys.retry) {
            // Sucesso não exibe toast: a própria tela seguinte é a confirmação.
            this.selfieActive = false

            this.$router.push({
              name: dataAnalisys.nextStep
            })
          }

          if (dataAnalisys.retry) {
            this.selfieActive = false
            this.openRetryAlert()
            const err = new Error(`Não foi possível validar selfie. [retry] Transaction: [${this.dataAccess}].`)
            Sentry.captureException(err)
          }
        } else {
          const erroData = error.data
          const { message: messageKey } = erroData

          this.openTerminalAlert(this.$t(`errors.${messageKey}`) || SELFIE_MESSAGES.genericFailure)

          const err = new Error(`Não foi possível validar selfie. Transaction: [${this.dataAccess}].`)
          Sentry.captureException(err)
        }
      } catch (error) {
        console.error('error: ', error)
        this.openTerminalAlert(SELFIE_MESSAGES.validationFailure)

        const err = new Error(`Ocorreu uma falha no processo de validação da selfie. [tente novamente]. Transaction: [${this.dataAccess}].`)
        Sentry.captureException(err)
      }
    },
    async restartProcess() {
      this.setRetryFaceCapture()
      const link = await this.resetProcessUser()
      this.$router.push({
        path: '/',
        query: {
          y: link
        }
      })
    },
    async initRiskDevice() {
      if (this.riskDevice && !this.deviceToken) {
        await IncogniaWebSdk.init({ appId: this.riskDeviceId })
        this.deviceToken = await IncogniaWebSdk.generateRequestToken()
      }
    }
  }
}
</script>
<style lang="scss">
.scrollable-container {
  overflow-y: auto;
  max-height: 100vh;
}
.page-selfie-face {
  height: 100%;
  .flex-image {
    margin-top: 4rem;
  }
  .card-img {
    max-width: 180px!important;
    max-height: 180px;
    margin: .8rem 0;
  }
  .alert-message {
    display: block!important;
    p {
      margin-bottom: .8rem;
    }
  }
  .position-relative,
  .container,
  .row {
    height: 100%;
  }
  .btn {
    max-height: 43px;
  }
  .text-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  img,
  video {
    height: auto;
    max-width: none!important;
  }
}
.selfie-ilustration {
    width: 10rem;
    height: 10rem;
    margin-bottom: 1rem;
}
.instructions {
    display: flex;
    flex-direction: column;
    margin: 1rem 2.5rem 1rem 2.5rem;
 p {
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    color: #111214;
    padding: 0.5rem 0;
    padding-left: 0.8rem;
 }
 .content-instruction {
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #E5E7EB;
    font-family: var(--font-family-text)!important;
 }
}
@media (min-width: 768px) {
  .scrollable-container {
    max-height: 100vh;
  }
    .instructions {
    margin: 0 1.5rem 1rem 1.5rem;
  }
}
</style>
